import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function useHandlerException() {
  const navigate = useNavigate();
  const goTo = (to) => {
    switch (to?.response?.status) {
      case 401:
        navigate("/noAutorizado");
        break;
      case 500:
        // navigate("/error");
        break;
      default:
        break;
    }
  };
  return { goTo };
}
/**
 * Devuelve un customHook con la fecha actual segun el separador indicado
 *
 * @param {String} separator
 * @returns Fecha Actual
 */
export function useCurrentDate(separator = "") {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  const [currentDate, setCurrentDate] = useState(() => {
    const currentDate = `${year}${separator}${
      month < 10 ? `0${month}` : `${month}`
    }${separator}${date < 10 ? `0${date}` : `${date}`}`;
    return currentDate;
  });

  return [currentDate, setCurrentDate];
}

/**
 * Obtiene la fecha y la hora actual segun el separador indicado
 *
 * @param {String} separator
 * @returns Fecha y horal actual
 */
export function getCurrentDateWithHour(separator = "") {
  const fechaActual = new Date();
  const date = fechaActual.getDate();
  const month = fechaActual.getMonth() + 1;
  const year = fechaActual.getFullYear();

  const fecha = `${date}${separator}${
    month < 10 ? `0${month}` : `${month}`
  }${separator}${year}`;
  return fecha + " " + getHours();
}

/**
 * Obtiene la fecha en formato cadena segun un objeto
 *
 * @param {Date} fechaSeleccionada
 * @returns Fecha en cadena
 */
export function getDateStringByObject(fechaSeleccionada) {
  if (fechaSeleccionada == null) return undefined;
  const dia = fechaSeleccionada.getDate();
  const mes = fechaSeleccionada.getMonth() + 1;
  const anio = fechaSeleccionada.getFullYear();
  const fecha = `${dia < 10 ? `0${dia}` : `${dia}`}/${
    mes < 10 ? `0${mes}` : `${mes}`
  }/${anio}`;

  return fecha;
}
/**
 * Obtiene una fecha con una cadema de formato
 * dd/MM/yyyy
 */
export function getDateFromString(fechaSeleccionada) {
  if (fechaSeleccionada == null) return undefined;
  const fechaActualSplit = fechaSeleccionada.split("/");
  return new Date(
    fechaActualSplit[2],
    fechaActualSplit[1] - 1,
    fechaActualSplit[0]
  );
}

/**
 * Obtiene la fecha actual en formato dd/MM/yy
 */
export function getCurrentDateYearString2() {
  const date = new Date();
  const dia = date.getDate();
  const mes = date.getMonth() + 1;
  const anio = parseInt(date.getFullYear().toString().substring(2));
  return `${dia < 10 ? `0${dia}` : `${dia}`}/${
    mes < 10 ? `0${mes}` : `${mes}`
  }/${anio < 10 ? `0${anio}` : `${anio}`}`;
}

/**
 * Obtiene la fecha selecciona en formato dd/MM/yy
 * a partir de un string
 */
export function getFechaSeleccionadaDateYearString2(fechaSeleccionada) {
  if (typeof fechaSeleccionada === "object") {
    return null;
  }
  
  const fechaSeleccionadaSplit = fechaSeleccionada.split("/");
  const dia = parseInt(fechaSeleccionadaSplit[0]);
  const mes = parseInt(fechaSeleccionadaSplit[1]);
  const anio = parseInt(fechaSeleccionadaSplit[2].substring(2));
  return `${dia < 10 ? `0${dia}` : `${dia}`}/${
    mes < 10 ? `0${mes}` : `${mes}`
  }/${anio < 10 ? `0${anio}` : `${anio}`}`;
}

/**
 * Obtiene la fecha selecciona en formato yyyy-MM-dd
 * a partir de un string de fecha con formato dd/MM/yyyy
 */
export function getFechaSeleccionadaDateYearString3(fechaSeleccionada) {
  if (typeof fechaSeleccionada === "object") {
    return null;
  }

  const fechaSeleccionadaSplit = fechaSeleccionada.split("/");
  const dia = parseInt(fechaSeleccionadaSplit[0]);
  const mes = parseInt(fechaSeleccionadaSplit[1]);
  const anio = 2024;
  return `${anio < 10 ? `0${anio}` : `${anio}`}-${
    mes < 10 ? `0${mes}` : `${mes}`
  }-${dia < 10 ? `0${dia}` : `${dia}`}`;
}

/**
 * Obtiene la fecha selecciona en formato dd/MM/yy
 * a partir de un Date
 */
export function getFechaSeleccionadaDateYear2(fechaSeleccionada) {
  const dia = fechaSeleccionada.getDate();
  const mes = fechaSeleccionada.getMonth() + 1;
  const anio = parseInt(
    fechaSeleccionada.getFullYear().toString().substring(2)
  );
  return `${dia < 10 ? `0${dia}` : `${dia}`}/${
    mes < 10 ? `0${mes}` : `${mes}`
  }/${anio < 10 ? `0${anio}` : `${anio}`}`;
}

export function parseoString_Date(str) {
  const date = new Date(str);
  return date;
}

/**
 * Filtro para la búsqueda de campos de una tabla
 *
 * @param {String} columna
 *      Item con el nombre de la columna
 * @param {String} elemen
 *      Elemento que proviene del filtro
 * @returns
 */
export function condicionFiltroTabla(columna, elemen) {
  return columna !== null
    ? columna
        .toLocaleLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .includes(
          elemen
            .toLocaleLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
        )
    : "";
}

export function getStringFromDate(fechaSeleccionada) {
  const dia = fechaSeleccionada.getDate();
  const mes = fechaSeleccionada.getMonth() + 1;
  const anio = fechaSeleccionada.getFullYear();
  return `${dia < 10 ? `0${dia}` : `${dia}`}-${
    mes < 10 ? `0${mes}` : `${mes}`
  }-${anio < 10 ? `0${anio}` : `${anio}`}`;

  // return `${fechaSeleccionada.getDate()}-${fechaSeleccionada.getMonth() +
  //   1}-${fechaSeleccionada.getFullYear()}`
}
export function getStringFromDateBar(fechaSeleccionada) {
  return `${fechaSeleccionada.getDate()}/${
    fechaSeleccionada.getMonth() + 1
  }/${fechaSeleccionada.getFullYear()}`;
}

export function getFechaActualConHoras() {
  let fechaHoy = new Date();
  let dia = fechaHoy.getDate();
  let mes = fechaHoy.getMonth() + 1;
  let anio = fechaHoy.getFullYear();
  let horas = fechaHoy.getHours();
  let mins = fechaHoy.getMinutes();
  let secs = fechaHoy.getSeconds();
  const fechaActual = `${dia < 10 ? `0${dia}` : `${dia}`}/${
    mes < 10 ? `0${mes}` : `${mes}`
  }/${anio}`;
  const horaActual = `${horas}:${mins < 10 ? `0${mins}` : `${mins}`}:${
    secs < 10 ? `0${secs}` : `${secs}`
  }`;
  return fechaActual + " " + horaActual;
}

//Comprueba que una hora de incio sea mayor a una hora final
export function comprobarHoras(horaDesde, horaHasta) {
  let arrayDesde = horaDesde.split(":");
  let arrayHasta = horaHasta.split(":");

  if (parseInt(arrayDesde[0].trim()) < parseInt(arrayHasta[0].trim())) {
    return true;
  } else {
    return false;
  }
}

/**
 * Transforma una cadena a minuscula y la capitaliza
 *
 * @param {*} str
 * @returns
 */
export function capitalizar(str) {
  if (str === null || str === undefined) return "";
  const lower = str.toLocaleLowerCase().replace("_", " ");
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

/**
 *
 * Obtiene las horas, minutos y segundos actuales.
 *
 * @returns tiempo
 */
function getHours() {
  let date = new Date();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();

  return `${hours}:${minutes}:${seconds < 10 ? `0${seconds}` : `${seconds}`}`;
}

/**
 * Obtener el dia en año a partir de una fecha como string
 *
 * @param {*} date
 * @returns
 */
export function getDayOfYear(dateString) {
  let date = new Date(dateString);
  const timestamp1 = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  const timestamp2 = Date.UTC(date.getFullYear(), 0, 0);

  const differenceInMilliseconds = timestamp1 - timestamp2;

  const differenceInDays = differenceInMilliseconds / 1000 / 60 / 60 / 24;

  return differenceInDays;
}

/**
 * Convierte horas y minutos a minutos
 * Examples:
 * "09:00" return 540
 * "02:20" return 140
 */
export function formateaHora(horas) {
  const BASE_HOURS_MINUTES = "00:00";
  const MINUTES = 60;
  if (horas == null || horas === "" || BASE_HOURS_MINUTES === horas) return 0;
  let hora;
  let mins;

  if (horas.includes("-")) {
    hora = horas.substring(1, 3);
    mins = horas.substring(4);
    return (hora * MINUTES + mins) * -1;
  } else {
    hora = horas.substring(0, 2);
    mins = horas.substring(3);
  }

  return hora * MINUTES + mins;
}

/**
 * Convierte los minutos a horas y minutos en formato 00:00
 * Examples:
 * "540" return "09:00"
 * "140" return "02:20"
 */
export function formateaMinutos(duration) {
  const BASE_HOURS_MINUTES = "00:00";
  var durationAux = duration;
  if (duration < 0) {
    durationAux = duration * -1;
  }

  let hours = Math.floor(durationAux / 60);
  let minutes = durationAux % 60;

  let strHours = hours < 10 ? "0" + hours.toString() : hours.toString();
  let strMin = minutes < 10 ? "0" + minutes.toString() : minutes.toString();

  let tiempo = strHours + ":" + strMin;

  if (duration < 0) return duration != null ? "-" + tiempo : BASE_HOURS_MINUTES;
  return duration != null ? tiempo : BASE_HOURS_MINUTES;
}
/**
 * Elimina una propiedad en específico de un objeto, los dos datos se introducen por parámetros.
 * Examples:
 * Quitamos la propiedad c del siguiente objeto
 * {a:1, b:2, c:3} return {a:1, c:3}
 */
export function eliminarPropiedadObj(obj, prop) {
  obj = Object.keys(obj).reduce((object, key) => {
    if (key !== prop) {
      object[key] = obj[key];
    }
    return object;
  }, {});
  return obj;
}

export function formateoNumeroEuro(cantidad) {
  const formatterEuro = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  const amount = formatterEuro
    .formatToParts(cantidad)
    .filter((p) => p.type !== "currency")
    .map((p) => p.value)
    .join("")
    .trim();
  return amount;
}

export function formateoFecha(fecha) {
  let fechaSep = fecha.split("-");
  let fechaNueva = `${fechaSep[2]}-${fechaSep[1]}-${fechaSep[0]}`;
  return fechaNueva;
}
export function formateoFechaConBarra(fecha) {
  fecha = fecha.split("-");
  fecha = `${fecha[2]}/${fecha[1]}/${fecha[0]}`;
  return fecha;
}

/**
 * Obtiene una fecha con una cadema de formato
 * dd/MM/yyyy
 */
export function getDateFromStringToObj(fechaSeleccionada) {
  if (fechaSeleccionada == null) return undefined;
  const fechaActualSplit = fechaSeleccionada.split("-");
  return {
    mes: fechaActualSplit[1],
    anio: fechaActualSplit[0],
    dia: fechaActualSplit[2],
  };
}

/* Formateo fechas tipo Date recibidas del backend a dd/mm/yy */
export function getFechaFromUtilDate(fechaSeleccionada) {
  if (fechaSeleccionada == null) return undefined;
  const fecha = fechaSeleccionada.format(`DD/MM/YYYY`);
  return fecha;
}
/* Formateo fechas y horas tipo TimeStamp recibidas del backend a dd/MM/yyyy HH:mm:ss */
export function getFechaFromUtilTimeStamp(fechaSeleccionada) {
  if (fechaSeleccionada == null) return undefined;
  // Parsear la fecha original
  const fechaParseada = new Date(fechaSeleccionada);

  // Formatear la fecha parseada en el formato deseado
  const formatoDeseado = new Intl.DateTimeFormat("es", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const fechaFormateada = formatoDeseado.format(fechaParseada);
  return fechaFormateada;
}

export function base64ToByteArray(base64String) {
  if (!base64String) {
    throw new Error("Cadena Base64 vacía o nula");
  }

  // Elimina encabezado si está presente
  const cleanBase64 = base64String.replace(/^data:.*?base64,/, '').replace(/[\r\n\s]/g, '');

  // Valida estructura base64
  const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  if (!base64Regex.test(cleanBase64)) {
    throw new Error("Cadena Base64 inválida");
  }

  // Decodifica
  const binaryString = atob(cleanBase64);
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }

  return byteArray;
}

export function base64ToBlob(base64Data, contentType = '', sliceSize = 512) {
  // Limpieza de la cadena Base64 (opcional)
  const cleanedBase64 = base64Data.replace(/^data:[^;]+;base64,/, '');
  // Decodificar Base64 a bytes
  const byteCharacters = atob(cleanedBase64);
  const byteArrays = [];
  // Dividir en chunks para evitar problemas de memoria
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }
  // Crear el Blob
  return new Blob(byteArrays, { type: contentType });
}